export enum SelectionPanelBorderRadius {
    None = 'noRadius',
    Small = 'smallRadius',
    Medium = 'mediumRadius',
}
